import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserProfileService } from '../../../features/user-profile/user-profile.service';
import { UtilityService } from '../utility/utility.service';

import { APP_SETTINGS } from '@services';
@Injectable()
export class AppSettingsService {

  constructor(private httpClient: HttpClient,
    private userProfileService: UserProfileService,
    private utilityService: UtilityService) { }

  initializeApp(): Promise<any> {
    return new Promise<void>((resolve, reject) => {

      let brandType;
      this.userProfileService.getUserRoles().subscribe(data => {
        if (data.hasOwnProperty('username')) {
          brandType = data['isMini'];
          APP_SETTINGS.brandType = brandType;
          APP_SETTINGS.isBMW = data.isBMW;
          APP_SETTINGS.isMINI = data.isMini;
          APP_SETTINGS.isAdmin = data.isAdmin;
          APP_SETTINGS.isExternal = data.isExternal;
          APP_SETTINGS.isBPMAdmin = data.isBPMAdmin;
          APP_SETTINGS.isMasterAdmin = data.isMasterAdmin;
          APP_SETTINGS.isPartAdmin = data.isPartAdmin;
          APP_SETTINGS.isSIBAdmin = data.isSIBAdmin;
          APP_SETTINGS.sessionId = data.sessionId;
          APP_SETTINGS.isDealer = data.isDealer;
         
          if (data.isMini === 'true') {
            APP_SETTINGS.videoThumbnail = APP_SETTINGS.miniVideoThumbnail;
            APP_SETTINGS.videoThumbnailHeight = "45px";
            APP_SETTINGS.videoThumbnailWidth = "20px";
          }
          if (data.isRollsRoyce === 'true') {
            APP_SETTINGS.videoThumbnail = APP_SETTINGS.rollsRoyceVideoThumbnail;
            APP_SETTINGS.videoThumbnailHeight = "45px";
            APP_SETTINGS.videoThumbnailWidth = "20px";
          }
          // else {
          //   APP_SETTINGS.videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
          //   APP_SETTINGS.videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;
          // }

          // this.utilityService.changeBrandType(brandType);
        }
      });



      setTimeout(() => {
        // doing something

        resolve();
      }, 1000);
    });
  }

  getSettings(): Promise<any> {

    const promise = this.httpClient.get('http://private-1ad25-initializeng.apiary-mock.com/settings')
      .toPromise()
      .then(settings => {

        return settings;
      });

    return promise;
  }
}